module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"trip":"Trip","saveJson":"Save JSON","cancel":"Cancel"},"no":{"trip":"Tur","saveJson":"Lagre JSON","cancel":"Avbryt"}}')
  delete Component.options._Ctor
}
